import React, { useState, useEffect, useCallback } from "react";
import "../../../index.css";
// import Heading from "../Typography/Heading";
import { useLocation } from "react-router-dom";
// import SecondaryHeading from "../Typography/SecondaryHeading";
import SpecialText from "../Typography/SpecialText";
import AuxiliaryText from "../Typography/AuxiliaryText";

export default function RangeSlider({
  units,
  minimum,
  starting,
  maximum,
  values,
  onChange,
  ...restProps
}) {
  const location = useLocation();
  const [sliderValue, setSliderValue] = useState(starting);

  const updateSliderBackground = useCallback((value, sliderEl) => {
    const width = window.innerWidth;
    const color1 = width < 1024 ? '#2E00FF' : '#2E00FF';
    const color2 = width < 1024 ? '#FFFFFF' : '#E8F0FF';
    
    const progress = ((value - minimum) / (maximum - minimum)) * 100;
    if (sliderEl) {
      sliderEl.style.background = `linear-gradient(to right, ${color1} ${progress}%, ${color2} ${progress}%)`;
    }
  }, [maximum, minimum]);

  const handleSliderChange = useCallback((event) => {
    const newValue = parseInt(event.target.value);
    setSliderValue(newValue);
    onChange({ target: { value: newValue } });
  }, [onChange]);

  useEffect(() => {
    const sliderEl = document.querySelector("#range2");
    if (!sliderEl) return;

    // Initial background update
    updateSliderBackground(sliderValue, sliderEl);

    // Add event listener
    sliderEl.addEventListener("input", handleSliderChange);

    // Handle resize
    const handleResize = () => {
      updateSliderBackground(sliderValue, sliderEl);
    };
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => {
      sliderEl.removeEventListener("input", handleSliderChange);
      window.removeEventListener("resize", handleResize);
    };
  }, [sliderValue, handleSliderChange, updateSliderBackground]);

  return (
    <>
      {location.pathname.includes("SellerDashboard/Posting/CreatePost") ? (
        <label className="value2 mb-1 mt-2 flex justify-center text-center">
          <AuxiliaryText variant={"Placeholder"} className={"text-offblack"}>
            {sliderValue} {units}
          </AuxiliaryText>
        </label>
      ) : (
        <SpecialText variant={"ExtraLargeNumber"} className={"flex justify-center text-offblack"}>
          {sliderValue} {units}
        </SpecialText>
      )}
      <div className="range">
        <input
          {...restProps}
          type="range"
          min={minimum}
          max={maximum}
          step={1}
          defaultValue={starting}
          value={sliderValue}
          id="range2"
        />
      </div>
    </>
  );
}
